import Cookie from "js-cookie";
import { refreshToken } from "@/@core/utils/refreshToken";
import { getTime } from "date-fns";

let interval;

// Checks if the token is expired every 30 seconds
const CHECK_TOKEN_INTERVAL = 30;
// If the token is less than TIME_TO_REFRESH_TOKEN seconds from expiration, refresh the token
const TIME_TO_REFRESH_TOKEN = 180;

function init() {
  if (interval) stop();

  interval = setInterval(async () => {
    const authCookie = Cookie.get("jwt_hp");
    if (!authCookie) return;

    const parsedAuthCookie = JSON.parse(atob(authCookie.split(".")[1]));

    if (tokenExpiresSoon(parsedAuthCookie.exp)) {
      try {
        await refreshToken();
      } catch (e) {
        console.error(e);
      }
    }
  }, CHECK_TOKEN_INTERVAL * 1000);
}

function stop() {
  clearInterval(interval);
}

function tokenExpiresSoon(timeStamp) {
  const expirationTime = timeStamp * 1000; // Convert to milliseconds
  const currentTime = getTime(new Date());
  const timeUntilExpiration = (expirationTime - currentTime) / 1000;

  return timeUntilExpiration <= TIME_TO_REFRESH_TOKEN;
}

export { init, tokenExpiresSoon, stop };
